<div class="lay-wrapper footer-wrapper">
    <div class="footer-links">
        <div class="flex-spacer"></div>
        <p (click)="openLink('https://www.siemens-healthineers.com')">Siemens Healthcare GmbH, © {{ currentYear }}</p>
        <p (click)="openLink('https://www.siemens-healthineers.com/corporate-info')">Corporate Information</p>
        <p (click)="openLink('https://www.siemens-healthineers.com/siemens-website-privacy-policy')">Privacy Policy</p>
        <p (click)="openLink('https://www.siemens-healthineers.com/cookie')">Cookie Policy</p>
        <p (click)="openLink('https://www.siemens-healthineers.com/terms-of-use')">Terms of use</p>
        <p (click)="openLink('https://www.siemens-healthineers.com/corporate/digital-services-act')">
            Digital Services Act
        </p>
        <div class="flex-spacer"></div>
    </div>
</div>
